import React, { FC } from "react";
import { Layout, Menu, Row, Col } from "antd";
import { NavLink } from "react-router-dom";

import { MagicPagesTypes } from "../../../../services/enums";
import { UIRoutes } from "../../../../router";
import SubscribeForm from "../../../Subscribes/Form";

export interface MenuItem {
  name: string;
  id: MagicPagesTypes;
  segment?: string;
  url?: string;
}

const AppFooter: FC = () => {
  const links: MenuItem[] = [
    {
      name: "Copyright",
      segment: "copyright",
      id: MagicPagesTypes.Copyright,
    },
    {
      name: "Terms of Use",
      segment: "terms_conditions",
      id: MagicPagesTypes.Terms,
    },
    {
      name: "Privacy Policy",
      segment: "privacy_policy",
      id: MagicPagesTypes.PrivacyPolicy,
    },
    {
      name: "Advertising",
      segment: "advertising",
      id: MagicPagesTypes.Advertising,
    },
    {
      name: "Contact Us",
      segment: "contact",
      id: MagicPagesTypes.Contacts,
    },
    {
      name: "Press",
      segment: "press",
      id: MagicPagesTypes.Press,
    },
    {
      name: "Change Log",
      url: `/${UIRoutes.HOME_CHANGE_LOG}`,
      id: MagicPagesTypes.ChangeLogs,
    },
    //todo: uncomment when inplemented
    // {
    //   name: "Api",
    //   segment: "api",
    //   id: MagicPagesTypes.Api,
    // },
    // {
    //   name: "Widgets",
    //   segment: "widgets",
    //   id: MagicPagesTypes.Widgets,
    // },
  ];

  return (
    <div className="dark-theme">
      <Layout.Footer>
        <Row>
          <Col xs={24} sm={10} md={8}>
            <div className="d-flex align-items-center h-100 pl-1">
              © Copyright 2017-2022 The Blockchain Academy LLC | All Rights
              Reserved
            </div>
          </Col>

          <Col xs={24} sm={14} md={16}>
            <div style={{ display: 'inline-table', width: '100%' }}>
              <div style={{ width: '30vw', float: 'right', }}>
                <h4 style={{ color: '#fff' }}>Subscribe to our news</h4>
                <SubscribeForm />
              </div>
            </div>

            <Menu theme="dark" mode="horizontal" selectable={false}>
              {links.map((el: MenuItem) => (
                <Menu.Item key={el.id}>
                  <NavLink
                    className={(navData) => (navData.isActive ? "active" : "")}
                    to={
                      el.url
                        ? el.url
                        : `/${UIRoutes.VIEW_PAGE_BASE}/${el.segment}/${el.id}`
                    }
                  >
                    {el.name}
                  </NavLink>
                </Menu.Item>
              ))}
            </Menu>
          </Col>
        </Row>
      </Layout.Footer>
    </div>
  );
};

export default AppFooter;
